import { ToggleGroup, ToggleGroupItem } from "@/components/ui/toggle-group";
import { COUNT_BY_HINT } from "./matchOutcomeBuckets";
import type { MatchUnit } from "./useAnalyticsParams";

/** "Count by: Bill items / Bills". Both match sections write the same `unit` param, so changing one changes both. */
export function MatchCountByToggle({
  unit,
  onChange,
}: {
  unit: MatchUnit;
  onChange: (unit: MatchUnit) => void;
}) {
  return (
    <div>
      <div className="flex items-center gap-2">
        <span className="font-medium">Count by</span>
        <ToggleGroup
          type="single"
          variant="outline"
          size="sm"
          value={unit}
          onValueChange={(value) => {
            if (value) onChange(value as MatchUnit);
          }}
        >
          <ToggleGroupItem value="Lines">Bill items</ToggleGroupItem>
          <ToggleGroupItem value="Bills">Bills</ToggleGroupItem>
        </ToggleGroup>
      </div>
      <p className="text-muted-foreground mt-1 text-xs">{COUNT_BY_HINT}</p>
    </div>
  );
}
